import { fabric } from 'fabric';
import { getDarkOrLightColor } from '../helpers';
import extendCanvasGroupProps from './extendCanvasGroupProps';
import getUnitLabel from './getUnitLabel';

const TEXT_OFFSET = 0.05;

const addCanvasSquare = (data, color, dropOnX, dropOnY, borderColor) => {
    data.unit = Number(data.unit);

    const borderWidth = borderColor ? 3 : 0;
    const size = 20;
    const adjustedSize = size + borderWidth;

    const rect = new fabric.Rect({
        originX: 'center',
        originY: 'center',
        width: adjustedSize,
        height: adjustedSize,
        fill: color,
        stroke: borderColor || 'transparent',
        strokeWidth: borderWidth,
        padding: 10,
        hasRotatingPoint: false,
        type: 'rect',
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false
    });

    const textObject = new fabric.Text(getUnitLabel(data.unit), {
        fontFamily: 'Roboto, Arial, Sans-serif',
        fontWeight: 'normal',
        scaleY: 1 + TEXT_OFFSET,
        fontSize: 12 - TEXT_OFFSET,
        fill: getDarkOrLightColor(color || '', '#ffffff', '#000000'),
        type: 'text',
        attributeId: data.type,
        originX: 'center',
        originY: 'center',
        textAlign: 'center',
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false
    });

    extendCanvasGroupProps();

    return new fabric.Group([rect, textObject], {
        ...data,
        left: dropOnX + adjustedSize / 2,
        top: dropOnY + adjustedSize / 2,
        originX: 'center',
        originY: 'center',
        type: 'group',
        product: data.currentFiller || data.toxin,
        imageSmoothingEnabled: false,
        noScaleCache: false,
        objectCaching: false,
        shape: 'square',
        borderColor: borderColor,
        color: color
    });
};

export default addCanvasSquare;
